"use strict";

exports.__esModule = true;
exports.ClassificationPopupWidget = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var moment = _interopRequireWildcard(require("moment"));
var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));
var _styledComponents = require("styled-components");
var _Core = require("../../Core");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ClassificationPopupWidget = exports.ClassificationPopupWidget = function ClassificationPopupWidget(props) {
  (0, _momentDurationFormat["default"])(moment);
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var translate = translator.translate;
  var onClickNoButton = props.onClickNoButton,
    onClickYesButton = props.onClickYesButton,
    warningClassificationTime = props.warningClassificationTime;
  var formattedTime = moment.duration(warningClassificationTime).format("h:mm");
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    className: theme.bodyClassName,
    isOpen: true,
    onClose: onClickNoButton,
    style: {
      width: "450px"
    },
    title: translate("ClassificationPopupWidget.popup.title", "Cycle Classification")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "ClassificationPopupWidget.popup.info"
  }, translate("ClassificationPopupWidget.popup.info", "You have selected a cycle classification more then " + formattedTime + " hours")), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      marginTop: "1rem"
    },
    "data-testid": "ClassificationPopupWidget.popup.confirmation"
  }, " ", translate("ClassificationPopupWidget.popup.confirmation", "Do you wish to proceed?"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS,
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: modern,
    style: {
      marginLeft: "0px"
    },
    intent: _core.Intent.SECONDARY,
    onClick: onClickNoButton,
    "data-testid": "ClassificationPopupWidget.popupButton.No"
  }, translate("ClassificationPopupWidget.popupButton.No", "No")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: modern,
    intent: _core.Intent.PRIMARY,
    onClick: onClickYesButton,
    "data-testid": "ClassificationPopupWidget.popupButton.Yes"
  }, translate("ClassificationPopupWidget.popupButton.Yes", "Yes")))));
};